export interface ShippingProvider {
  id: number;
  slug: string;
  name: string;
  price: number;
  discountedPrice: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyShippingProvider = (): ShippingProvider => ({
  id: 0,
  slug: '',
  name: '',
  price: 0,
  discountedPrice: 0,
  isActive: false,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const shippingProviderFromResponse = (
  responseData: any,
): ShippingProvider => ({
  id: responseData.id,
  slug: responseData.slug,
  name: responseData.name,
  price: responseData.price,
  discountedPrice: responseData.discounted_price,
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const shippingProviderToUpsertRequest = (
  shippingProvider: ShippingProvider,
) => ({
  name: shippingProvider.name,
  price: shippingProvider.price,
  discounted_price: shippingProvider.discountedPrice,
  is_active: shippingProvider.isActive,
});
